import { gql } from '@apollo/client';

import { useQuery } from '@fhs/client';
import { useAuthContext } from '@fhs-legacy/frontend/src/state/auth';
import { client } from '@fhs-legacy/frontend/src/state/graphql/client';

import { GetGiftCardTransactionHistoryPayload } from '../utils/types';

const GetGiftCardTransactionHistoryQuery = gql`
  query GetGiftCardTransactionHistory @gateway @authRequired {
    getGiftCardTransactionHistory {
      giftCard {
        transactions {
          date
          type
          amount
          transactionChannel
        }
      }
    }
  }
`;

export const useGetGiftCardTransactionHistoryQuery = ({
  enabled = true,
}: { enabled?: boolean }) => {
  const { user } = useAuthContext();

  return useQuery({
    enabled,
    queryKey: ['getGiftCardTransactionHistory', user?.cognitoId],
    queryFn: async () => {
      const { data } = await client.query({
        query: GetGiftCardTransactionHistoryQuery,
        fetchPolicy: 'network-only',
      });
      return data?.getGiftCardTransactionHistory?.giftCard as GetGiftCardTransactionHistoryPayload;
    },
  });
};
